<template>
  <div class="parallax-container">
    <ul class="container collapsible">
      <li class="active">
        <LoginSection />
      </li>
      <li>
        <DashboardSection />
      </li>
    </ul>
    <div class="parallax">
      <img src="../assets/gombessa1.jpg" alt="Unsplashed background img 1" />
    </div>
  </div>
</template>


<script>
import LoginSection from "@/components/admin/LoginSection.vue";
import DashboardSection from "@/components/admin/DashboardSection.vue";
import M from "materialize-css";

export default {
  components: {
    LoginSection,
    DashboardSection
  },
  mounted() {
    // collapsible, mobile menu
    M.AutoInit();
    M.updateTextFields();
  }
};
</script>



<style scoped>
.collapsible-body {
  background-color: white;
  margin-top: 105px;
  margin-bottom: 0;
  color: rgba(0, 0, 0, 0.87);
}

@media (max-width: 600px) {
  body .parallax-container {
    background-color: white !important;
  }
}
</style>